import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalPublicProperties, PartnersPlanModalComponent as ModalComponent } from './partners-plan-modal.component';
import { cloneDeep } from 'lodash';

@Injectable({ providedIn: 'root' })
export class PartnersPlanModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions) {
    const newOptions = cloneDeep(options || {});
    newOptions.windowClass = (newOptions.windowClass || '').split(/\s+/).concat('sidemodal-right').join(' ');
    return this.modalService.open<boolean>(ModalComponent, properties || {}, newOptions);
  }
}
